export const DATATABLE_DELETE = 'DATATABLE_DELETE'
export const DATATABLE_COLUMNS = 'DATATABLE_COLUMNS'
export const DATATABLE_FILTERS = 'DATATABLE_FILTERS'
export const DATATABLE_ACTIONS = 'DATATABLE_ACTIONS'
export const DATATABLE_ACTION = 'DATATABLE_ACTION'
export const DATATABLE_RESTORE = 'DATATABLE_RESTORE'



// WEBPACK FOOTER //
// ./src/store/actions/datatable.js